import * as React from 'react';
import {ReactNode} from 'react';
import classnames from 'classnames';

import {truncateFirstDot} from 'features/services/utils/string-helpers';
import {ImageSizes} from 'components/organisms/Shell/image-size-enum';

import './style.scss';

import {A} from 'components/atoms/LinksAndButtons/A';
import { LinkStyle, ReadMoreAlign, HeadlineLevel, HeadlineFont } from 'features/ui/enums';
import {P} from 'components/atoms/Text/P';
import {ReadMore} from 'components/atoms/LinksAndButtons/ReadMore';
import {AsyncImage} from 'components/atoms/Media/AsyncImage';
import {EpiImage} from "features/search/types";
import {Headline} from 'components/atoms/Text/Headline';

interface Props {
    title: string;
    text: string;
    linkUrl: string;
    linkText?: string;
    image?: EpiImage;
    className?: string;
    customReadMore?: ReactNode;
    onClick?: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    id?: string;
    noTruncate?: boolean;
    filterField?: string;
}

export const ArticleTeaser: React.FunctionComponent<Props> = ({title, text, linkUrl, linkText, image, className, customReadMore, onClick, id, noTruncate, filterField: _filterField}) => {
    const classes = classnames('article-teaser', className, {});

    return (
        <A
            href={linkUrl}
            onClick={onClick}
            variant={LinkStyle.UNSTYLED}
            route={linkUrl !== null && linkUrl.indexOf('http') === -1}
            className={classes}
            id={id} 
            title={title}
        >
            {image &&
                <div className="article-teaser__image">
                    <AsyncImage
                        image={image}
                        quality={ImageSizes.SIZE_600}
                        fullWidth
                        alt={title}
                    />
                </div>
            }
            <div className="article-teaser__content">
                <Headline level={HeadlineLevel.H4} font={HeadlineFont.SERIF} center>{title}</Headline>
                <P center>{noTruncate ? text : truncateFirstDot(text)}</P>
                {!customReadMore && <ReadMore block align={ReadMoreAlign.CENTER} text={linkText} /> }
                {customReadMore && customReadMore}
            </div>
        </A>
    )
};
